import React, { FC } from 'react';
import Tooltip from '@mui/material/Tooltip';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { EopResult } from '@modules/EvaluationModule/enums/EopResult';
import { EvaluationType } from '@modules/EvaluationModule/enums/EvaluationType';
import { getEvaluationTerms } from '@shared/helpers/evaluationTerminology';
import { useStyles } from './EoTIndicator.styles';

const ClockIcon = <AccessTimeOutlinedIcon sx={{ fontSize: 18, color: 'action.disabled' }} />;
const InfoIcon = <InfoOutlinedIcon sx={{ fontSize: 18, color: 'action.disabled' }} />;

interface Props {
  typeOfInteraction: EvaluationType;
  eopStatus?: string;
  eopNotPassedReason?: string;
  eopExtendedReason?: string;
  officeCountry?: string;
}

export const EoTIndicator: FC<Props> = ({
  typeOfInteraction,
  eopStatus,
  eopNotPassedReason,
  eopExtendedReason,
  officeCountry,
}) => {
  const styles = useStyles();

  if (typeOfInteraction !== EvaluationType.EndOfProbation) {
    return null;
  }

  const hasReason =
    (eopStatus === EopResult.NotPassed && eopNotPassedReason) ||
    (eopStatus === EopResult.Extended && eopExtendedReason);

  if (!hasReason) {
    return ClockIcon;
  }

  const reason = eopStatus === EopResult.NotPassed ? eopNotPassedReason : eopExtendedReason;

  return (
    <Tooltip
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: 'transparent',
            p: 0,
            maxWidth: 'none',
          },
        },
      }}
      title={
        <div className={styles.root}>
          <div className={styles.header}>
            <div className={styles.title}>{getEvaluationTerms(officeCountry).periodLabel}</div>
          </div>
          <div className={styles.divider} />
          <div className={styles.body}>{reason}</div>
        </div>
      }
    >
      {InfoIcon}
    </Tooltip>
  );
};
